<template>
  <div class="page">

    <div class="container">
      <div class="button-container">
        <div class="title-text">我的提问</div>
        <img class="question-mark" src="./assets/img2/question-mark.png"/>
        <div class="btn btn-poweroff align-center justify-center" v-on:click="onUserClickCancelQuestion()">
          <img src="./assets/img2/poweroff.png"/>
          <span style="margin-left:3px;">结束提问</span>
        </div>

        <div v-if="userAsking.photoBase64Data" style="position: absolute;right:40%; top:5%; height:90%;">
          <img :src="userAsking.photoBase64Data" style="height:100%;min-width:40px; cursor:zoom-in" v-on:click="mainObj.showImage(userAsking.photoBase64Data)"/>
          <div style="position:absolute;right:0px;top:0px;width:20px;height:20px;color:red;text-align:center;vertical-align:center;cursor:pointer;background-color:#2c3e5055"
               v-on:click="userAsking.photoBase64Data=''">x</div>
        </div>

        <div class="btn btn-record align-center justify-center" v-on:click="onUserClickAudioInputForUserAsking()">
          <span v-if="!mainObj.bAudioRecording" class="text_2">语音输入</span>
          <span v-else class="text_2">结束录音</span>
        </div>
        <div class="btn btn-image align-center justify-center" v-on:click="bShowImageChooser=true">
          <span class="text_3">上传图片</span>
        </div>
        <div class="btn btn-confirm align-center justify-center" v-on:click="mainObj.bAudioRecording?'':onUserClickSendQuestion()">
          <span class="text_4">确认输入</span>
        </div>
      </div>
      <div class="input-container">
        <div class="title-text">我的提问</div>
        <div style="position:absolute;right:5%;top:8%;" :style="{color: userAsking.nWords>userAsking.nMaxWords ? '#ff8c8c':'#8c8c8c'}">
          {{userAsking.nWords}}/{{userAsking.nMaxWords}}
        </div>
        <textarea class="qa-input"
                  v-model="userAsking.qaText"
                  v-on:input="onUserInputChange"
                  placeholder="此处可以输入你的问题">
        </textarea>
        <div v-if="bShowAudioText" id="idUserAskDisplayAudioText" class="qa-input output-container my-content-div" ref="displayAudioTextContainer"
             style="top:3%; height: 94%">
          <MarkMathRenderer :content="displayAudioText" style="position: relative; left: 0%; top: 0%; width: 100%; height:100%;"/>
        </div>
      </div>
      <div class="output-container my-content-div" id="idUserAskDisplayBoardText" ref="displayBoardContainer">
        <MarkMathRenderer :content="displayBoardText" style="position: relative; left: 0%; top: 0%; width: 100%; height:100%;"/>
      </div>
    </div>

    <image-chooser v-if="bShowImageChooser" @close="bShowImageChooser=false" @chosen="onImageChosen"/>

  </div>

</template>


<script>
import {countWordsAndCharacters, sleep} from "@/util/util";
import {invokeLessonPlayerStreamWebApi} from "@/util/readapi";
import {nextTick} from "vue";
import MarkMathRenderer from "@/components/MarkMathRenderer.vue";
import html2canvas from "html2canvas";
import ImageChooser from "@/components/ImageChooser.vue";

export default {
  components: {
    MarkMathRenderer,
    ImageChooser
  },
  props: {
    askingData: {
      required: true
    },
    channel: null,
    mainObj: null,
  },
  data() {
    return {
      userAsking: {},
      bShowAudioText: false,
      displayAudioText: '', //口语字幕（口语转换之前的书面语）
      displayBoardText: '', //板书
      bShowImageChooser: false
    };
  },
  watch: {
    askingData: {
      immediate: true,
      async handler(newContent) {
        this.userAsking = newContent;
      }
    },
    channel: {
      immediate: true,
    }
  },
  methods: {

    onUserClickCancelQuestion: function () {
      this.userAsking.bPlaying = false;
      if(this.userAsking.qaUsingVideoOrCartoon) {
        this.mainObj.stopUserAskingQuestionsVideo();
      }
      if(this.userAsking.lastAnswerPlayer) {
        this.mainObj.stopMediaPlayer(this.userAsking.lastAnswerPlayer);
      }
      let img = document.getElementById('qaTriggerImage');
      if(img) img.src = this.channel.userAskTriggerWantToAskImg(this.mainObj.queries.lessonId);
      this.userAsking.photoBase64Data = '';
      this.userAsking.bShowView = false;
    },

    onUserInputChange: function() {
      let r = countWordsAndCharacters(this.userAsking.qaText);
      this.userAsking.nWords = r.totalCount;
    },

    onUserClickAudioInputForUserAsking: function () {
      if(this.userAsking.lastAnswerPlayer) {
        this.mainObj.stopMediaPlayer(this.userAsking.lastAnswerPlayer);
      }
      let thiz = this;
      let mainObj = this.mainObj;
      let begin = 0;
      let onRecordStarted = function (beginTimeMillis) {
        begin = beginTimeMillis;
        mainObj.audioRecorderSeconds = 60;
      };
      let onRecordWavFile = function(file) {
        mainObj.voiceToText(file, thiz.userAsking.currentAction, function(text) {
          if(thiz.userAsking.qaAutoVoice) {
            if(thiz.userAsking.qaText && thiz.userAsking.qaText.length > 0)
              text = text + ': ' + thiz.userAsking.qaText;
            thiz.onUserClickSendQuestionInner(text);
          } else {
            thiz.userAsking.qaText = text;
          }
        });
      };
      let onRecordDuration = function (durationTimeMillis) {
        let seconds = (durationTimeMillis - begin) / 1000;
        mainObj.audioRecorderSeconds = 60 - seconds;
        if(thiz.mainObj.audioRecorderSeconds <= 0) {
          mainObj.startOrStopAudioRecording(onRecordStarted, onRecordWavFile, onRecordDuration);
        }
      };

      mainObj.startOrStopAudioRecording(onRecordStarted, onRecordWavFile, onRecordDuration);
    },

    onUserClickSendQuestionInner: async function (qaText) {
      console.log("onUserClickSendQuestion:", qaText);
      this.userAsking.qaAnswer = '';
      this.userAsking.markdown = '';
      let jxgbox = document.getElementById('jxgbox');
      if(jxgbox) {
        jxgbox.innerHTML = '';
      }
      if (!qaText && !this.userAsking.photoBase64Data) {
        return;
      }
      let param = {
        robotStyle: this.userAsking.currentAction.robotStyle,
        voiceActor: this.userAsking.currentAction.voiceActor,
        volume    : this.userAsking.currentAction.volume,
        sectionId : this.userAsking.currentAction.sectionId || 0,
        sections  : this.userAsking.currentAction.sections,
        qaText    : qaText,
        photoBase64: this.userAsking.photoBase64Data
      };

      let thiz = this;
      let mainObj = this.mainObj;

      let idx = Math.round(Math.random());
      let mp3_url = idx==0 ? require('@/assets/robot_thinking_1.mp3') : require('@/assets/robot_thinking_2.mp3');
      let robot_voice_player_a = mainObj.playSound(mp3_url, () => {
        robot_voice_player_a.play().catch(async function (err) {
          console.error('play robot-voice-a error:', err, err.name, err.message);
        });
      });
      robot_voice_player_a.volume = robot_voice_player_a.volume / 2 / 3 / 2 / 2;

      //使用stream
      {
        thiz.userAsking.qaText = '';
        thiz.userAsking.qaAnswer = '【您的提问】\r\n' + qaText + '\r\n\r\n';
        const stop_robot_voice_player_a = function () {
          if (robot_voice_player_a) {
            robot_voice_player_a.pause();
            mainObj.freeStaticAudioPlayer(robot_voice_player_a);
            robot_voice_player_a = null;
          }
        };

        let queue = [];
        let bDone = false;
        invokeLessonPlayerStreamWebApi(mainObj.queries, 'ask-question-cartoon-stream', param, thiz.toLogin,
            (oneObj)=>{
              if(oneObj.qaTextAdj) {
                thiz.userAsking.qaAnswer = '【您的提问】\r\n' + oneObj.qaTextAdj + '\r\n\r\n';
              }
              else if(oneObj.isGptWholeReply) {
                console.log('GG-all-ua2:', oneObj.reply);
              }
              else if(oneObj.isTarget) {
                console.log('GG-target-ua2:', oneObj.target);
                if(window.location.href.indexOf('grammar=true') > 0) {
                  thiz.userAsking.grammarTarget = oneObj.target;
                  thiz.userAsking.bShowGrammarView = true;
                }
              }
              else {
                console.log('GG-item-ua2:', oneObj.audioText);
                stop_robot_voice_player_a();
                queue.push(oneObj);
              }
            },
            (err)=>{
              stop_robot_voice_player_a();
              bDone = true;
              if (err) {
                console.log(err);
              }
            }
        );
        ////

        if(thiz.displayBoardText && thiz.displayBoardText.length > 0) {
          thiz.displayBoardText += "\n\n---\n";
        }

        let idx = 0;
        while (thiz.userAsking.bPlaying && (!bDone || idx < queue.length)) {
          if (idx < queue.length) {
            let item = queue[idx];
            
            if (item.dispText) { //语音书面文本
              thiz.bShowAudioText = true;
              thiz.displayAudioText += item.dispText;
              await mainObj.scrollToBottomEnd('idUserAskDisplayAudioText')
            }
            if (item.markdown) { //板书文本
              thiz.displayBoardText += item.markdown;
              await mainObj.scrollToBottomEnd('idUserAskDisplayBoardText')
            }
            if (item.graphicCode) { //图形代码
              await thiz.injectJSXGraphCode(item.graphicCode);
            }
            if (item.audioText && item.audioUrl) {
              await mainObj.playUserAskingQuestionsCartoon(item.audioUrl);
              if(thiz.userAsking.bPlaying)
                await sleep(1000);
            }
            idx++;
          }
          else if(thiz.userAsking.bPlaying) {
            await sleep(500);
          }
        }
      }

      setTimeout(() => {
        this.bShowAudioText = false;
        this.displayAudioText = '';
        this.userAsking.photoBase64Data = '';
      }, 2000);
    },

    onUserClickSendQuestion: function () {
      let mainObj = this.mainObj;
      if(this.userAsking.nWords > this.userAsking.nMaxWords) {
        mainObj.showErrorMsg(1000, '不要超过 '+this.userAsking.nMaxWords+' 个单词或汉字');
        return;
      }
      if(this.userAsking.lastAnswerPlayer) {
        mainObj.stopMediaPlayer(this.userAsking.lastAnswerPlayer);
      }
      this.onUserClickSendQuestionInner(this.userAsking.qaText);
    },

    injectJSXGraphCode: async function (dynamicJavascript) {
      let clearjs = `
        if(window.boardVars) {
          delete window.boardVars;
          window.boardVars = null;
        }
        if(window.board) {
          delete window.board;
          window.board = null;
        }
      `;

      if (this.userAsking.jsxGraphNode) {
        this.userAsking.jsxGraphNode.remove()
      }

      // 创建一个 <script> 标签
      this.userAsking.jsxGraphNode = document.createElement('script');

      // 将 JS 代码作为文本内容注入到 script 标签中
      this.userAsking.jsxGraphNode.textContent = clearjs + dynamicJavascript;

      // 将 script 标签添加到当前文档的 <body> 中
      document.body.appendChild(this.userAsking.jsxGraphNode);

      await nextTick();
      let thiz = this;
      let div = document.getElementById('jxgbox');
      html2canvas(div).then(async function (canvas) {
        // 将 canvas 转换为图片的 data URL
        let imgData = canvas.toDataURL('image/png');

        // 将截图显示
        thiz.displayBoardText += '\n![](' + imgData + ')\n';
//        await thiz.displayBoardContainerScroll();
        await thiz.mainObj.scrollToBottomEnd('idUserAskDisplayBoardText')
      });
    },

    updateUserAskPhotoBase64Data: function (blob) {
      let thiz = this;
      let reader = new FileReader();
      reader.onload = function (event) {
        thiz.userAsking.photoBase64Data = event.target.result;
      }
      reader.readAsDataURL(blob);
    },

    onImageChosen: function(imageUrl, file) {
      console.log('onImageChosen imageUrl=', imageUrl);
      console.log('onImageChosen file=', file);
      this.updateUserAskPhotoBase64Data(file);
      this.bShowImageChooser = false;
    }


  }
};
</script>
<style lang="css" src="./assets/common.css"/>
<style scoped lang="css" src="./assets/index.abs.css" />
